'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.telFilter = telFilter;
var angular = require('angular');

/*@ngInject*/
function telFilter() {
  return function (tel) {
    if (!tel) {
      return '';
    }

    var value = tel.toString().trim().replace(/^\+/, '');

    if (value.match(/[^0-9]/)) {
      return tel;
    }

    var country;
    var city;
    var number;

    switch (value.length) {
      case 10:
        country = 1;
        city = value.slice(0, 3);
        number = value.slice(3);
        break;

      case 11:
        country = value[0];
        city = value.slice(1, 4);
        number = value.slice(4);
        break;

      case 12:
        country = value.slice(0, 3);
        city = value.slice(3, 5);
        number = value.slice(5);
        break;

      default:
        return tel;
    }

    if (country == 1) {
      country = '';
    }

    number = number.slice(0, 3) + '-' + number.slice(3);

    return (country + ' (' + city + ') ' + number).trim();
  };
}

exports.default = angular.module('parkingformApp.tel', []).filter('tel', telFilter).name;


// WEBPACK FOOTER //
// ./client/app/filters/tel/tel.filter.js